import {
    Grid,
    TextField,
    IconButton,
    Button,
    FormControlLabel,
    Switch, MenuItem,
    Box,
    Divider,
    Tooltip,
    Snackbar
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import React, {useEffect, useState} from "react";
import Widget from "../../../components/BetterWidget";
import {Typography} from "../../../components/Wrappers";
import {Add, DeleteOutline, Launch, Person, LocationOn, Phone, Email, ContactMail} from "@material-ui/icons";
import PageTitle from "../../../components/PageTitle";
import Rest from "../../../helpers/Rest";
import ProgressOr from "../../../components/ProgressOr";
import GooglePlacesAutocompleteField from "../../../components/GooglePlacesAutocompleteField";
import timezones from "../../../helpers/timezones";
import {Autocomplete} from "@material-ui/lab";

const DEFAULT_TIME_ZONE = 'Pacific/Auckland'
const OPTIONAL_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const isValidOptionalEmail = (value) => {
    const trimmed = (value || '').trim()
    return !trimmed || OPTIONAL_EMAIL.test(trimmed)
}

const removeSite = (sites, site) => {
    const replace = []
    sites.forEach(function(item){
        if (site.id !== item.id){
            replace.push(item)
        }
    })
    return replace
}

const siteCardStyle = {
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: '20px 24px 16px',
    position: 'relative',
    backgroundColor: '#fafafa',
}

const sectionLabelStyle = {
    fontSize: '0.7rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: '#9e9e9e',
    marginBottom: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 4
}

const Site = ({site, sites, setSites, setEdited, disabled}) => {
    const [name, setName] = useState(site.name)
    const [timeZone, setTimeZone] = useState(site.timezone)
    const [address, setAddress] = useState(site.address)
    const [contactPerson, setContactPerson] = useState(site.contact_person || '')
    const [contactPhone, setContactPhone] = useState(site.contact_phone || '')
    const [contactEmail, setContactEmail] = useState(site.contact_email || '')
    const invalidContactEmail = !isValidOptionalEmail(contactEmail)
    return (
        <Grid item xs={12}>
            <Box style={siteCardStyle}>
                <Box style={{position: 'absolute', top: 12, right: 12}}>
                    <Tooltip title="Remove site">
                        <IconButton size="small" disabled={disabled} onClick={() => {
                            setSites(removeSite(sites, site))
                            setEdited(true)
                        }}>
                            <DeleteOutline fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextField variant="outlined" label="Site Name" value={name} onChange={(e) => {
                            setName(site.name = e.target.value)
                            setEdited(true)
                        }} disabled={disabled} fullWidth size="small"/>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <Autocomplete
                            renderInput={
                                props => <TextField
                                    {...props}
                                    variant="outlined"
                                    label="Time zone"
                                    disabled={disabled} fullWidth
                                    size="small"
                                    />
                            }
                            options={timezones}
                            value={timeZone || DEFAULT_TIME_ZONE}
                            onChange={(_, value) => {
                                setTimeZone(site.timezone = value || DEFAULT_TIME_ZONE)
                                setEdited(true)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={10} lg={5} style={{paddingRight: 40}}>
                        <GooglePlacesAutocompleteField label="Site Address" value={address} onChange={(address) => {
                            setAddress(site.address = address)
                            setEdited(true)
                        }} disabled={disabled} fullWidth size="small"/>
                    </Grid>

                    <Grid item xs={12}>
                        <Box style={sectionLabelStyle}>
                            <ContactMail style={{fontSize: 14}} />
                            Site Contact
                        </Box>
                        <Divider style={{marginBottom: 12}} />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            label="Name"
                            value={contactPerson}
                            onChange={(e) => {
                                setContactPerson(site.contact_person = e.target.value)
                                setEdited(true)
                            }}
                            disabled={disabled}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            label="Phone"
                            value={contactPhone}
                            onChange={(e) => {
                                setContactPhone(site.contact_phone = e.target.value)
                                setEdited(true)
                            }}
                            disabled={disabled}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            type="email"
                            label="Email"
                            value={contactEmail}
                            onChange={(e) => {
                                setContactEmail(site.contact_email = e.target.value)
                                setEdited(true)
                            }}
                            error={invalidContactEmail}
                            helperText={invalidContactEmail ? 'Invalid email address' : ' '}
                            disabled={disabled}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

const Sites = (props) => {
    if (!props.sites || props.sites.length === 0){
        return "";
    }
    return (
        <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} style={{paddingBottom: 0}}>
                <Box style={{display: 'flex', alignItems: 'center', gap: 8, marginTop: 8}}>
                    <LocationOn style={{color: '#E32C0F', fontSize: 20}} />
                    <Typography variant={"h2"} style={{margin: 0}}>Sites</Typography>
                    <Box style={{
                        backgroundColor: '#151614',
                        color: '#fff',
                        borderRadius: 12,
                        padding: '1px 10px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        lineHeight: '20px'
                    }}>
                        {props.sites.length}
                    </Box>
                </Box>
                <Divider style={{marginTop: 8}} />
            </Grid>
            {props.sites.map(site => (
                <Site site={site} key={site.id} {...props} />
                )
            )}
        </Grid>
    )
}

const cloneSite = (site) => {
    return {
        id: site.id,
        name: site.name,
        timezone: site.timezone,
        address: site.address,
        contact_person: site.contact_person || '',
        contact_phone: site.contact_phone || '',
        contact_email: site.contact_email || ''
    }
}

const cloneSites = (sites, pad) => {
    pad = (pad || 0)
    const len = sites.length
    const replace = new Array(len + pad)
    for (let i = 0; i < len; ++i){
        replace[i] = cloneSite(sites[i])
    }
    return replace
}

const getLastSiteId = (sites) => {
    const len = sites.length
    if (len === 0){
        return 1
    }
    const parts = /^_(\d+)$/.exec(sites[len - 1].id)
    if (!parts){
        return 1
    }
    return Number(parts[1]) + 1
}

const addSite = (sites) => {
    const replace = cloneSites(sites, 1)
    replace[replace.length - 1] = {
        id: getLastSiteId(sites),
        name: '',
        timezone: DEFAULT_TIME_ZONE,
        address: '',
        contact_person: '',
        contact_phone: '',
        contact_email: ''
    };
    return replace
}

const updateSites = (uri, sites, originalSites, promises) => {
    const set = {}
    originalSites.forEach((site) => {
        set[site.id] = site
    })
    sites.forEach((site) => {
        const original = set[site.id]
        const altered = {
            name: site.name,
            timezone: site.timezone,
            address: site.address,
            contact_person: site.contact_person,
            contact_phone: site.contact_phone,
            contact_email: site.contact_email
        }
        if (!original){
            promises.push(Rest.post(uri, altered).then((reply) => site.id = reply.id))
            return
        }
        if (site.name !== original.name || site.address !== original.address || site.timezone !== original.timezone ||
            site.contact_person !== original.contact_person || site.contact_phone !== original.contact_phone ||
            site.contact_email !== original.contact_email){
            promises.push(Rest.put(`${uri}/${site.id}`, altered));
        }
        delete set[site.id]
    })
    for (const id in set){
        promises.push(Rest.del(`${uri}/${id}`))
    }
}

const NO_ZEN_DESK = "-"

const saveCustomer = (name, showOwnership, showCameraReporting, pduAllocationExempt, zenDeskTag, sites, original) => {
    let uri = `customer/${original.id}`
    const promises = []
    const originalZenDeskTag = original.zen_field || NO_ZEN_DESK
    if (name !== original.name ||
        showOwnership !== original.show_ownership ||
        showCameraReporting !== (original.show_camera_reporting || false) ||
        pduAllocationExempt !== (original.pdu_allocation_exempt || false) ||
        zenDeskTag !== originalZenDeskTag){
        const data = {
            show_ownership: showOwnership,
            show_camera_reporting: showCameraReporting,
            pdu_allocation_exempt: pduAllocationExempt,
            name: name
        }
        if (zenDeskTag && zenDeskTag !== NO_ZEN_DESK){
            data.zen_field = zenDeskTag
        }
        promises.push(Rest.put(uri, data))
    }
    updateSites(`${uri}/site`, sites, original.sites, promises)
    const errors = []
    const settled = promises.map(p => p.catch(err => { errors.push(err) }))
    return Promise.all(settled).then(() => {
        if (errors.length > 0) {
            throw String(errors[0])
        }
    });
}

export default (props) => {
    const customer = props.location.state;
    if (!customer || !customer.name){
        props.history.push('list-customers');
        return "";
    }
    const [sites, setSites] = useState(cloneSites(customer.sites))
    const [edited, setEdited] = useState(false)
    const [zenDeskTag, setZenDeskTag] = useState(customer.zen_field || NO_ZEN_DESK)
    const [zenDeskTags, setZenDeskTags] = useState([])
    const [name, setName] = useState(customer.name)
    const [saving, setSaving] = useState(false)
    const [showOwnership, setShowOwnership] = useState(customer.show_ownership || false)
    const [showCameraReporting, setShowCameraReporting] = useState(customer.show_camera_reporting || false)
    const [pduAllocationExempt, setPduAllocationExempt] = useState(customer.pdu_allocation_exempt || false)
    const [saveError, setSaveError] = useState(null)
    const hasInvalidSiteEmail = sites.some(site => !isValidOptionalEmail(site.contact_email))

    useEffect(() => {
        Rest.get("zendesk/customer_options")
            .then(options => {
                if (options.ticket_field){
                    setZenDeskTags(
                        options.ticket_field.custom_field_options
                    )
                }
            })
            .catch(() => {
                setZenDeskTags([])
            })
    }, []);

    return (
        <div>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Typography variant="h5" style={{color: '#9e9e9e'}}>{name}</Typography>
                <div>
                    <Button
                        endIcon={<Person/>}
                        target="dashboard"
                        href={`/dashboard/${customer.id}/account`}
                        color="primary"
                    >
                        Edit Users
                    </Button>
                    <Button
                        endIcon={<Launch/>}
                        target="dashboard"
                        href={`/dashboard/${customer.id}`}
                        color="primary"
                    >
                        Dashboard
                    </Button>
                </div>
            </div>
            <Widget>
                <Grid container spacing={2} style={{maxWidth:"1000px"}}>
                    <Grid item xs={12}>
                        <Typography variant={"h2"}>Customer</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField variant="outlined" label="Customer Name" value={name} onChange={(e) => {
                            setName(e.target.value)
                            setEdited(true)
                        }} disabled={saving} fullWidth size="small"/>
                    </Grid>
                    <Grid item xs={12} style={{marginTop: 8}}>
                        <Typography variant="h2">Settings</Typography>
                        <Divider style={{marginTop: 8}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            label="Zendesk tag"
                            value={zenDeskTag}
                            onChange={e => {
                                setZenDeskTag(e.target.value)
                                setEdited(true)
                            }}
                            select
                            fullWidth
                            size="small"
                        >
                            <MenuItem value={NO_ZEN_DESK}>None</MenuItem>
                            {zenDeskTags.map(item => <MenuItem value={item.value} key={item.value}>{item.name}</MenuItem>)}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} style={{display: 'flex', alignItems: 'center'}}>
                        <FormControlLabel
                            control={<Switch checked={showOwnership} onChange={(_, show) => {
                                setShowOwnership(show)
                                setEdited(true)
                            }}/>}
                            label="Show Registered Users Name"
                            labelPlacement="start"
                            style={{marginLeft: 0}}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} style={{display: 'flex', alignItems: 'center'}}>
                        <FormControlLabel
                            control={<Switch checked={showCameraReporting} onChange={(_, show) => {
                                setShowCameraReporting(show)
                                setEdited(true)
                            }}/>}
                            label="Show Camera Reporting"
                            labelPlacement="start"
                            style={{marginLeft: 0}}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} style={{display: 'flex', alignItems: 'center'}}>
                        <Tooltip title="PDUs owned by this customer stay put, and its Masters, chargers and APTs never pull other PDUs in. Use for staff, contractor and demo kit.">
                            <FormControlLabel
                                control={<Switch checked={pduAllocationExempt} onChange={(_, exempt) => {
                                    setPduAllocationExempt(exempt)
                                    setEdited(true)
                                }}/>}
                                label="Never Move PDUs Automatically"
                                labelPlacement="start"
                                style={{marginLeft: 0}}
                            />
                        </Tooltip>
                    </Grid>
                    <Sites sites={sites} setSites={setSites} setEdited={setEdited} disabled={saving}/>
                    <Grid item xs={12}>
                        <Button
                            startIcon={<Add/>}
                            color="primary"
                            disabled={saving}
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                setSites(addSite(sites))
                                setEdited(true)
                            }}
                            style={{borderStyle: 'dashed', marginTop: 4}}
                        >
                            Add Site
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider style={{marginTop: 8, marginBottom: 8}} />
                    </Grid>
                    <ProgressOr showProgress={saving} progressMessage={`Update ${name}...`}>
                        <Grid item xs={12} style={{textAlign: "right", paddingBottom: 8}}>
                            <Button variant="outlined" style={{marginRight:"16px"}} onClick={() => {
                                if (!edited){
                                    props.history.push('list-customers');
                                    return;
                                }
                                setSites(cloneSites(customer.sites))
                                setName(customer.name)
                                setShowOwnership(customer.show_ownership || false)
                                setShowCameraReporting(customer.show_camera_reporting || false)
                                setPduAllocationExempt(customer.pdu_allocation_exempt || false)
                                setZenDeskTag(customer.zen_field || NO_ZEN_DESK)
                                setEdited(false)
                            }}>Cancel</Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!edited || hasInvalidSiteEmail}
                                onClick={() => {
                                    setSaving(true)
                                    saveCustomer(name, showOwnership, showCameraReporting, pduAllocationExempt, zenDeskTag, sites, customer).then(() => {
                                        customer.name = name
                                        customer.show_ownership = showOwnership
                                        customer.show_camera_reporting = showCameraReporting
                                        customer.pdu_allocation_exempt = pduAllocationExempt
                                        customer.sites = cloneSites(sites)
                                        customer.zen_field = zenDeskTag === NO_ZEN_DESK ? null : zenDeskTag
                                        setEdited(false)
                                        setSaving(false)
                                    }).catch((error) => {
                                        setSites(cloneSites(customer.sites))
                                        setName(customer.name)
                                        setShowOwnership(customer.show_ownership || false)
                                        setShowCameraReporting(customer.show_camera_reporting || false)
                                setPduAllocationExempt(customer.pdu_allocation_exempt || false)
                                        setZenDeskTag(customer.zen_field || NO_ZEN_DESK)
                                        setEdited(false)
                                        setSaving(false)
                                        setSaveError(String(error) || "Failed to save changes")
                                    })
                                }}
                            >Save</Button>
                        </Grid>
                    </ProgressOr>
                </Grid>
            </Widget>
            <Snackbar open={!!saveError} autoHideDuration={6000} onClose={() => setSaveError(null)}>
                <Alert onClose={() => setSaveError(null)} severity="error" variant="filled">
                    {saveError}
                </Alert>
            </Snackbar>
        </div>
    )
}
